import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getCountriesRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/countries");

  return response.data;
};
